import { RootState } from 'product-personalizer/src/store';

import getPersonalizationErrors from './getPersonalizationErrors';

/**
 * Submission gate for personalization. Returns false when any text field has a
 * validation error — currently: empty mandatory fields, or locked-box fields
 * at/over their maxCharCount. Per-field codes live in getPersonalizationErrors.
 */
const getPersonalizationIsValid = (state: RootState): boolean =>
  Object.keys(getPersonalizationErrors(state)).length === 0;

export default getPersonalizationIsValid;
